<template>
  <section id="landing" class="overflow-hidden">
    <!-- intro -->
    <v-container inner fill-height>
      <v-layout row wrap fill-height justify-center align-center tag="article" class="article-wrapper">
        <v-flex xs12 class="text-xs-center">
          <span class="font-secondary white--text">People & Society / Asia-wide</span>
        </v-flex>

        <v-flex xs12>
          <h1 class="display-3 font-secondary white--text text-xs-center">Understanding the Belt & Road</h1>
        </v-flex>

        <v-flex xs12 class="text-xs-center">
          <div>
            <address class="font-secondary white--text mb-2">by Peiying Loh</address>

            <time class="font-secondary white--text">
              <strong class="mr-1">Published</strong> 28 September 2018
            </time>

            <p class="caption font-weight-bold white--text mt-4">
              <span style="background-color: #F2784B">For full data and map interactions, please switch to desktop.</span>
            </p>
          </div>
        </v-flex>

        <v-flex align-self-end text-xs-center>
          <div class="white--text font-secondary">
            <fa-icon :icon="['far', 'long-arrow-down']" fixed-width size="lg" />
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- video background -->
    <div class="video-wrapper">
      <video
        preload="none"
        poster="@/assets/img/brivideo-poster.jpg"
        ref="briVideo"
        playsinline
        autoplay
        loop
        muted>

        <source src="@/assets/video/BRI.mp4" type="video/mp4">
        Your browser doesn't support HTML5 video.
      </video>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionLanding',
  mounted() {
    // play the video
    this.$refs.briVideo.play();
  },
};
</script>

<style lang="stylus" scoped>
#landing {
  position: relative;
  width: 100%;
  height: calc(100vh - 64px);
  display: flex;

  .article-wrapper {
    z-index: 1;
  }

  .video-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    min-width: 100%; 
    min-height: 100%;

    &:before {
      content: '';
      background: rgba(0, 0, 0, 0.4);
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }
}
</style>
